/**
 * Minimal page fragment for routing and SEO (no mainRegionCollection).
 * PDP critical path: resolve productId and Contentful SEO without the 25-type region union.
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/king-living/app/contentful/fragments/page/base-page.fragment';
import {BaseSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/base-seo.fragment';

export const PageFragmentShell = gql`
  ${BasePageFragment}
  ${BaseSeoFragment}

  fragment PageFragmentShell on Page {
    ...BasePageFragment
    seo {
      ...BaseSeoFragment
    }
  }
`;
